import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _FixedAssetItemsWithDefeatDates } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../core/services/Singleton";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../theme/Component/usePaginator";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectFixedAsset } from "../../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { SelectStoreEditor } from "../../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";


export const FixedAssetItemsWithDefeatDates = () => {

    const FixedAssetItemsWithDefeatDates = useDataBean(_FixedAssetItemsWithDefeatDates);
    // const employeeContracttofunctional = useDataBean(_FunctionalAreaToEmployee);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [form, setform] = useState<any>({
        Name: null,
        asset: null,
        placa: null
    })
    const [storeID, setstoreID] = useState<number>(null)
    const [Account, setAccount] = useState<any>(null);
    const [date, setdate] = useState<any>(_single.getCurrenDate());
    const [fixed, setfixed] = useState<any>(null);
    const [state, setstate] = useState<any>(null);
    const [employetype, setemployetype] = useState<any>(null);
    const [functional, setFuntional] = useState<any>(null);
    const [IDLnSiteID, setIDLnSiteID] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [defeatDays, setdefeatDays] = useState<any>(30);
    const [Fornight, setFornight] = useState<any>(null);
    const [NameList, setNamelist] = useState<any>(null);
    const [Appointment, setAppointment] = useState<any>(null);
    const [EntailmentName, setEntailmentName] = useState<any>(null);
    const [records, setRecords] = useState<number>(15);
    const [modaldefinirplaza, setModaldefinirplaza] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        FixedAssetItemsWithDefeatDates.instance.getFixedAssetItemsWithDefeatDates(defeatDays, date, form.asset, regexStr, Account, storeID, state, paginador.page, 15).then(
            (resp) => {
                //console.log(resp.NumberOfPages)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                setLista(resp.List)
            }
        )
    }

    const head = [
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Elemento', property: 'Name', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Fecha Vencimiento Póliza Seguro', property: 'SecurityPolicyDefeat', visible: true },
        { title: 'Fecha Último Avalúo', property: 'LastAppraisal', visible: true },
        { title: 'Fecha Última Valorización', property: 'LastValuation', visible: true },
        { title: 'Fecha Baja de Activo', property: 'WithDrawDate', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Doc', property: 'Mnemonic', visible: true },
        { title: 'Num Doc', property: 'Consecutive', visible: true },

    ]


    const listaBotones = () => {
        const botones = [

            { titulo: '', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModaldefinirplaza({ ...modaldefinirplaza, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Alertas de Vencimientos en Activos Fijos">

            <div className="row">

                <div className="col-md-4">
                    <label>Dias de Vencimiento</label>
                    <input type="text" className="form-control" value={defeatDays} onChange={(e) => { setdefeatDays(e.target.value) }} />
                </div>

                <div className="col-md-4">
                    <InputDate name="initDate" label="Fecha de Corte" value={date} setDate={(e: any) => { setdate(e) }} />
                </div>
                <div className="col-md-4">
                    <label>Activo Fijo</label>
                    <SelectFixedAsset render={form.Name} idSelector={form.asset} onChange={(e) => { setform({ ...form, "asset": e.IDFixedAsset, "Name": e.Description }) }} label=" " returnType="Object" />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e) }} label="Proveedor/Responsable" />
                </div>
                <div className="col-md-4">
                    <SelectStoreEditor label='Almacén/Bodega' idSelector={storeID} onChange={(e) => { setstoreID(e.IDStore) }} />
                </div>
                <div className="col-md-4">
                    <label>Estado Lista:</label>
                    <select className="form-control" value={state} onChange={(e: any) => { setstate(e.target.value) }} >
                        <option value={NaN}>...</option>
                        <option value={0}>ITEM_AVAILABLE</option>
                        <option value={1}>ITEM_IN_USE</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable
                        head={head}
                        body={lista}
                        rowSet={FixedAssetItemsWithDefeatDates.setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={records}
                    />
                </div>
            </div>

        </BasicPage>
    )
}